import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { GetRunsRequest, GetRunsResponse } from './runs.types'
import { getRuns } from './runs'

const getRunsQueryKeys = {
  all: ['runs'] as const,
  of: ({ suite, project }: GetRunsRequest) => ['runs', suite, project] as const,
}

export const useGetRuns = (
  request?: GetRunsRequest
): UseQueryResult<GetRunsResponse | undefined> => {
  return useQuery<GetRunsResponse | undefined>({
    queryKey: request ? getRunsQueryKeys.of(request) : getRunsQueryKeys.all,
    queryFn: () => getRuns(request),
  })
}
